<router-outlet>
  <div class="np-loader" *ngIf="showLoader">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</router-outlet>
